export default __webpack_public_path__ + "16fa9b2e5db5e7dca430ee11b30659f6.svg";